import { QuestionType } from '@workflow-admin/shared/workflow/utils/workflow';
import { ActionType } from "@workflow-admin/shared/workflow/utils/workflow";

export const actionTypeLabel = {
  [ActionType.Mail]: "Mail",
  [ActionType.Pdf]: "Pdf",
  [ActionType.Hubspot]: "Hubspot",
  [ActionType.Validate]: "Validate"
}
